import { render } from "./kubeovn.io.vpc.vue?vue&type=template&id=413992a2&scoped=true"
import script from "./kubeovn.io.vpc.vue?vue&type=script&lang=js"
export * from "./kubeovn.io.vpc.vue?vue&type=script&lang=js"

import "./kubeovn.io.vpc.vue?vue&type=style&index=0&id=413992a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-413992a2"]])

export default __exports__